import React, { useCallback, useEffect, useState } from 'react';
import DataTable from '../components/common/Table';
import EventsFilterBar from '../components/events/EventsFilterBar';
import Pagination from '../components/common/Pagination';
import Modal from '../components/common/Modal';
import { getList } from '../api/events';
import { useEventsFilters } from '../hooks/useEventsFilters';
import { SpeedingEvent } from '../types';
import { speedBadge } from '../utils/speedBadge';
import './Pages.css';

const MyEventsPage: React.FC = () => {
  const [events, setEvents] = useState<SpeedingEvent[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState<SpeedingEvent | null>(null);
  const { filters, update, reset, apiParams } = useEventsFilters();

  const load = useCallback(async () => {
    try {
      const res = await getList({ page, ...apiParams });
      setEvents(res.items);
      setTotal(res.total);
    } catch { /* ignore */ }
  }, [page, apiParams]);

  useEffect(() => { load(); }, [load]);

  const columns = [
    { key: 'car_number', label: '차량번호' },
    { key: 'max_speed_kmh', label: '최고속도', render: (e: SpeedingEvent) => speedBadge(e.max_speed_kmh, e.warning_speed_kmh) },
    { key: 'warning_speed_kmh', label: '경고속도', render: (e: SpeedingEvent) => `${e.warning_speed_kmh} km/h` },
    { key: 'speed_limit_kmh', label: '제한속도', render: (e: SpeedingEvent) => `${e.speed_limit_kmh} km/h` },
    { key: 'entered_at', label: '입차시각', render: (e: SpeedingEvent) => new Date(e.entered_at).toLocaleString('ko-KR') },
    { key: 'detected_at', label: '감지시각', render: (e: SpeedingEvent) => new Date(e.detected_at).toLocaleString('ko-KR') },
  ];

  return (
    <div>
      <div className="page-header">
        <h2>나의 과속 이력</h2>
      </div>
      <EventsFilterBar filters={filters} onChange={update} onReset={() => { reset(); setPage(1); }} showApartmentName />
      <DataTable columns={columns} data={events} onRowClick={setSelected} />
      <Pagination page={page} total={total} limit={20} onPageChange={setPage} />

      <Modal isOpen={!!selected} onClose={() => setSelected(null)} title="이벤트 상세">
        {selected && (
          <div>
            <div className="form-group"><label>차량번호</label><p>{selected.car_number}</p></div>
            <div className="form-group"><label>최고속도</label><p>{selected.max_speed_kmh} km/h</p></div>
            <div className="form-group"><label>경고속도 / 제한속도</label><p>{selected.warning_speed_kmh} / {selected.speed_limit_kmh} km/h</p></div>
            <div className="form-group"><label>입차</label><p>{new Date(selected.entered_at).toLocaleString('ko-KR')}</p></div>
            <div className="form-group"><label>감지</label><p>{new Date(selected.detected_at).toLocaleString('ko-KR')}</p></div>
            <div className="form-group"><label>출차</label><p>{selected.exited_at ? new Date(selected.exited_at).toLocaleString('ko-KR') : '-'}</p></div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default MyEventsPage;
